import React from "react";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Container } from "reactstrap";

import { ListPage } from "./pages/ListPage";
import { UserPage } from "./pages/UserPage";
import { TablePage } from "./pages/TablePage";
import { NavigationBar } from "./components/NavigationBar";
import { TodoDrawer } from "./components/TodoDrawer";
import { ThemeProvider } from "./components/ThemeProvider";
import { caseInsensitiveUserId } from "./utils";

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <div>
          <NavigationBar />
          <TodoDrawer />

          <Container
            className="my-5"
            style={{ width: "100%", maxWidth: "90%" }}
          >
            <Switch>
              <Route
                path="/user/:userId([a-zA-Z0-9_]+)"
                render={({ match }): React.ReactElement => {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                  const params: { userId: string } = match.params;
                  const userId = caseInsensitiveUserId(params.userId);
                  return <UserPage userId={userId} />;
                }}
              />
              <Route
                path="/table/:userId([a-zA-Z0-9_]*)?"
                render={({ match }): React.ReactElement => {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                  const params: { userId?: string } = match.params;
                  const userId = caseInsensitiveUserId(params.userId ?? "");
                  return <TablePage userId={userId} />;
                }}
              />
              <Route
                path="/list/:userId([a-zA-Z0-9_]*)?"
                render={({ match }): React.ReactElement => {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                  const params: { userId?: string } = match.params;
                  const userId = caseInsensitiveUserId(params.userId ?? "");
                  return <ListPage userId={userId} />;
                }}
              />

              {/*Default Path*/}
              <Redirect path="/" to="/table/" />
            </Switch>
          </Container>
        </div>
      </Router>
    </ThemeProvider>
  );
};

// eslint-disable-next-line import/no-default-export
export default App;
